<template>
  <div class="ma-4">
    <ConfirmationDialog
      @confirmed="confirmLocationClockIn"
      :onSetConfirmedDialog="setConfirmedDialog"
      :confirmedDialog="$store.state.confirmedDialogCommon"
      :title="titleDialog"
      :content="contentDialog"
    />
    <StaffNav
      :emp-id="empID"
      :triggerStaffNavReactiveness="triggerStaffNavReactiveness"
      @triggerStaffInfoTimesheetTableReactiveness="reactiveTimesheetTable"
    />
    <v-row>
      <v-progress-linear
        v-model="value"
        :active="show"
        :indeterminate="query"
        :query="true"
        color="cyan"
      ></v-progress-linear>
      <v-snackbar v-model="msg" top :color="color" :vertical="true">
        {{ text }}
        <template v-slot:action="{ attrs }">
          <v-btn dark text v-bind="attrs" @click="msg = false"> Close</v-btn>
        </template>
      </v-snackbar>
      <v-col cols="12" lg="3" xl="2">
        <StaffSide />
      </v-col>
      <v-col cols="12" lg="6" xl="7">
        <v-data-table
          :headers="headers"
          :items="timeSheets"
          sort-by="ClockIn"
          sort-desc
          class="elevation-1"
          :loading="isLoading"
          loading-text="Loading Time Sheet"
          height="250"
        >
          <template v-slot:item.clockin="{ item }">
            <v-chip :color="getStatusColor(item.ClockInStatus)" dark>
              {{ item.clockin }}
            </v-chip>
          </template>
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title class="font-weight-light"
                >Time Sheet
              </v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-btn
                v-bind="size"
                outlined
                color="success"
                class="mt-2 mr-8 mb-3"
                @click="confirmClockIn()"
                :disabled="isDisableClockInButton"
                >CLOCK IN
              </v-btn>
              <v-btn
                v-bind="size"
                outlined
                color="error"
                class="mt-2 mb-3"
                @click="showCheckDialogForClockOut()"
                :disabled="isDisableClockOutButton"
                >CLOCK OUT
              </v-btn>
              <v-spacer></v-spacer>
              <v-dialog v-model="dialog" persistent max-width="75%">
                <v-card>
                  <v-card-title style="background-color: #2b3990">
                    <span class="headline white--text">{{ titleForm }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="6" sm="6" md="6">
                          <v-datetime-picker
                            v-model="newClockIn"
                            time-format="hh:mm a"
                            date-format="yyyy-MM-dd"
                            label="Clock In"
                          ></v-datetime-picker>
                          <!--
                                                    <v-menu
                                                        ref="clockInMenu"
                                                        :close-on-content-click="false"
                                                        :nudge-right="40"
                                                        :return-value.sync="newClockIn"
                                                        transition="scale-transition"
                                                        offset-y
                                                        max-width="290px"
                                                        min-width="290px"
                                                    >
                                                      <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field
                                                            v-model="newClockIn"
                                                            label="Clock In Time"
                                                            prepend-icon="mdi-clock-time-four-outline"
                                                            readonly
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        ></v-text-field>
                                                      </template>
                                                      <v-time-picker
                                                          v-model="newClockIn"
                                                          full-width
                                                          @click:minute="$refs.clockInMenu.save(newClockIn)"
                                                      ></v-time-picker>
                                                    </v-menu>
                                                    -->
                        </v-col>
                        <v-col cols="6" sm="6" md="6">
                          <v-datetime-picker
                            ref="childref"
                            v-model="newClockOut"
                            time-format="hh:mm a"
                            date-format="yyyy-MM-dd"
                            label="Clock Out"
                            @input="inputDate($event)"
                          ></v-datetime-picker>
                          <!--
                                                    <v-menu
                                                        ref="clockOutMenu"
                                                        :close-on-content-click="false"
                                                        :nudge-right="40"
                                                        :return-value.sync="newClockOut"
                                                        transition="scale-transition"
                                                        offset-y
                                                        max-width="290px"
                                                        min-width="290px"
                                                    >
                                                      <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field
                                                            :disabled="!clockOutAvailable"
                                                            v-model="newClockOut"
                                                            label="Clock Out Time"
                                                            time-format="hh:mm a"
                                                            date-format="yyyy-MM-dd"
                                                            prepend-icon="mdi-clock-time-four-outline"
                                                            readonly
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        ></v-text-field>
                                                      </template>
                                                      <v-datetime-picker
                                                          v-model="newClockOut"
                                                          full-width
                                                          @click:minute="
                                                          $refs.clockOutMenu.save(newClockOut)
                                                        "
                                                      ></v-datetime-picker>
                                                    </v-menu>
                                                    -->
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="callUpdates()"
                      >Update
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="closeUpdateTimeSheet"
                      >Cancel
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>

          <template v-slot:footer.prepend>
            <v-btn
              outlined
              class="btn-view-timesheet"
              color="blue lighten-1"
              :to="'/Timesheet/' + staffID"
              >View Full Timesheet
            </v-btn>
          </template>

          <template
            v-slot:[`item.actions`]="{ item }"
            v-if="allowAccessAction.includes(Role)"
          >
            <v-icon small class="mr-2" @click="viewTimeSheet(item)">
              mdi-eye
            </v-icon>
            <v-icon small @click="deleteTimeSheet(item)"> mdi-delete</v-icon>
          </template>
          <template v-slot:no-data>
            <v-btn @click="getTimeSheets()">Reset</v-btn>
          </template>
        </v-data-table>
        <template>
          <v-card class="mt-3 overflow-y-auto" height="47vh">
            <v-list>
              <v-subheader
                >Tasks - You have {{ tasks.length }} task(s) to complete
              </v-subheader>
              <v-divider class="ma-3"></v-divider>
              <v-list-item-group color="primary">
                <v-list-item
                  v-for="task in tasks"
                  :key="task._id"
                  class="pa-2 ma-1"
                  three-line
                  link
                >
                  <v-list-item-content>
                    <v-list-item-title>{{ task.Title }}</v-list-item-title>
                    <v-list-item-subtitle
                      >Due: {{ task.DueDate }}</v-list-item-subtitle
                    >
                    <v-list-item-subtitle
                      >Status: {{ task.Status }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn
                      v-if="task.Title !== 'Approved Completed Task'"
                      large
                      icon
                      @click="viewTask(task)"
                      class="mr-4"
                    >
                      <v-icon color="red lighten-1">mdi-information</v-icon>
                    </v-btn>

                    <!-- <v-btn
                                          v-if="task.Title !== 'Approved Completed Task'"
                                          large
                                          icon
                                          @click="complete(task._id)"
                                          class="mr-4"
                                          >
                                          <v-icon color="red lighten-1">mdi-information</v-icon>
                                        </v-btn> -->

                    <v-btn
                      v-if="task.Title === 'Approved Completed Task'"
                      x-small
                      @click="approve(task._id, task.CompletedTaskId)"
                      >Approve
                    </v-btn>
                  </v-list-item-action>

                  <!-- <v-flex xs3 class="mr-3">
                                      <v-list-item-title>Description</v-list-item-title>
                                      <v-list-item-subtitle>{{
                                          task.Description
                                        }}</v-list-item-subtitle>
                                    </v-flex> -->

                  <!-- <v-flex xs3 class="mr-3">
                                      <v-list-item-title>Status</v-list-item-title>

                                    </v-flex>

                                    <v-flex xs2>
                                      <v-btn v-if="task.Title !== 'Approved Completed Task'" x-small @click="complete(task._id)">Complete</v-btn>
                                      <v-btn v-if="task.Title === 'Approved Completed Task'" x-small @click="approve(task._id, task.CompletedTaskId)">Approve</v-btn>
                                    </v-flex> -->
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>
        </template>
      </v-col>
      <v-col cols="12" lg="3" xl="3">
        <v-card class="overflow-y-auto" height="100%">
          <v-col>
            <v-row>
              <v-col md="6" sm="6" xs="6">
                <v-btn
                  dark
                  small
                  color="indigo darken-4"
                  min-height="40"
                  elevation="0"
                  class="ml-15"
                  @click="getUpcomingShift()"
                >
                  <span color="white">Upcoming Shifts</span>
                </v-btn>
              </v-col>
              <v-col md="6" sm="6" xs="6">
                <v-btn
                  dark
                  small
                  color="indigo darken-4"
                  min-height="40"
                  elevation="0"
                  class="ml-15"
                  @click="printCalendar()"
                >
                  <v-icon small color="white"> mdi-printer </v-icon>
                  <span color="white">Print</span>
                </v-btn>
              </v-col>
            </v-row>
            <v-list>
              <v-divider></v-divider>
              <v-list-item
                v-for="shift in upcomingSchedule"
                :key="shift.counter"
                router
                :to="shift.route"
                @click="getStaffShift(shift)"
              >
                <v-list-item-avatar size="24">
                  <v-icon
                    small
                    :class="[shift.iconClass]"
                    v-text="shift.icon"
                  ></v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title v-text="shift.title"></v-list-item-title>
                  <v-list-item-subtitle
                    v-text="shift.clientName"
                  ></v-list-item-subtitle>

                  <v-list-item-subtitle
                    v-text="shift.subtitle"
                  ></v-list-item-subtitle>
                </v-list-item-content>

                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-list-item-action>
                      <v-btn icon v-on="on" v-bind="attrs">
                        <v-icon color="red lighten-1">mdi-information</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </template>
                  <span>{{ shift.Name }}</span>
                  <br />
                  <span class="font-weight-light"
                    ><!--PUT SOMETHING HERE--></span
                  >
                </v-tooltip>
              </v-list-item>
            </v-list>

            <v-dialog v-model="selectedStaffDialog" width="600px">
              <v-snackbar
                top
                v-model="editTimeClockInOutSnackbar"
                :timeout="5000"
              >
                {{ editTimeClockInOutSnackbarText }}
                <template v-slot:action="{ attrs }">
                  <v-btn
                    color="blue"
                    text
                    v-bind="attrs"
                    @click="editTimeClockInOutSnackbar = false"
                  >
                    Close
                  </v-btn>
                </template>
              </v-snackbar>
              <v-card>
                <v-card-title class="text-h6">
                  {{
                    isShowUpdateDateTimeBtn
                      ? "Update shift's date/time"
                      : "Schedule Info"
                  }}
                </v-card-title>

                <v-divider class="mb-3"></v-divider>
                <v-card-text>
                  <p class="mb-0">
                    Program:
                    {{ this.selectedStaff.ProgramName }}
                  </p>
                  <p class="mb-0">
                    Client(s):
                    {{ this.selectedStaff.clientName }}
                  </p>
                  <p class="mb-0">
                    Address:
                    {{ this.selectedStaff.Address }}
                  </p>
                  <v-container class="pt-0 pl-0">
                    <v-row>
                      <v-col class="d-flex pb-0" cols="12" md="1" sm="1">
                        <p class="mb-0">Notes:</p>
                      </v-col>
                      <v-col class="d-flex" cols="12" md="11" sm="11">
                        <p class="mb-0 pl-4">
                          {{ this.selectedStaff.Notes }}
                        </p>
                      </v-col>
                    </v-row>
                  </v-container>
                  <v-form
                    v-if="isShowUpdateDateTimeBtn"
                    ref="form"
                    lazy-validation
                  >
                    <v-row>
                      <v-col class="d-flex" cols="12" md="6" sm="6">
                        <v-datetime-picker
                          v-model="toUpdate_StartDatetime"
                          :text-field-props="textFieldProps"
                          :date-picker-props="startDateProps"
                          :time-picker-props="startTimeProps"
                          time-format="hh:mm a"
                          date-format="MM/dd/yyyy"
                          label="Update start shift"
                        ></v-datetime-picker>
                      </v-col>
                      <v-col class="d-flex" cols="12" md="6" sm="6">
                        <v-datetime-picker
                          v-model="toUpdate_EndDatetime"
                          :text-field-props="textFieldProps"
                          :date-picker-props="endDateProps"
                          :time-picker-props="endTimeProps"
                          time-format="hh:mm a"
                          date-format="MM/dd/yyyy"
                          label="Update end shift"
                        ></v-datetime-picker>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    v-if="isShowUpdateDateTimeBtn"
                    color="green darken-1"
                    text
                    :loading="updateUpcomingDateTime_btn"
                    :disabled="updateUpcomingDateTime_btn"
                    @click="updateUpcomingDateTime()"
                  >
                    Update
                  </v-btn>

                  <v-btn
                    color="secondary"
                    text
                    @click="selectedStaffDialog = false"
                  >
                    Close
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="checklistDialog" persistent max-width="900">
      <v-card>
        <v-toolbar color="primary" dark class="text-h5">Check List </v-toolbar>
        <v-card-text>
          <v-card>
            <v-tabs v-model="tab">
              <v-tab> TASK </v-tab>
              <v-tab> ADL </v-tab>
              <v-tab> MAR </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <v-card class="mt-3 overflow-y-auto" height="47vh">
                      <v-list>
                        <v-subheader
                          >Tasks - You have {{ tasks.length }} task(s) to
                          complete
                        </v-subheader>
                        <v-divider class="ma-3"></v-divider>
                        <v-list-item-group color="primary">
                          <v-list-item
                            v-for="task in tasks"
                            :key="task._id"
                            class="pa-2 ma-1"
                          >
                            <v-layout row wrap>
                              <v-flex xs3 class="ml-3">
                                <v-list-item-title>{{
                                  task.Title
                                }}</v-list-item-title>
                                <v-list-item-subtitle
                                  >Due:
                                  {{ task.DueDate }}
                                </v-list-item-subtitle>
                              </v-flex>

                              <v-flex xs3 class="mr-3">
                                <v-list-item-title
                                  >Description</v-list-item-title
                                >
                                <v-list-item-subtitle
                                  >{{ task.Description }}
                                </v-list-item-subtitle>
                              </v-flex>

                              <v-flex xs3 class="mr-3">
                                <v-list-item-title>Status</v-list-item-title>
                                <v-list-item-subtitle
                                  >{{ task.Status }}
                                </v-list-item-subtitle>
                              </v-flex>

                              <v-flex xs2>
                                <v-btn
                                  v-if="
                                    task.Title !== 'Approved Completed Task'
                                  "
                                  x-small
                                  @click="complete(task._id)"
                                  >Complete
                                </v-btn>
                                <v-btn
                                  v-if="
                                    task.Title === 'Approved Completed Task'
                                  "
                                  x-small
                                  @click="
                                    approve(task._id, task.CompletedTaskId)
                                  "
                                >
                                  Approve
                                </v-btn>
                              </v-flex>
                            </v-layout>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-card>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat>
                  <v-col cols="12" md="12" sm="12">
                    <v-card elevation="0" outlined>
                      <v-card-title class="mx-2 mt-1 mb-1"
                        >ADL
                        <v-btn
                          :to="'/adl/' + clientID"
                          absolute
                          right
                          small
                          class="mt-n1 cyan darken-3 white--text"
                          >View ADL
                        </v-btn>
                      </v-card-title>
                      <v-divider></v-divider>
                      <template v-for="serv in clientADL">
                        <v-expansion-panels :key="serv.ClientId">
                          <v-expansion-panel>
                            <v-expansion-panel-header>
                              <div>
                                <v-avatar size="40">
                                  <v-img :src="serv.Image"></v-img>
                                </v-avatar>
                                <span class="ml-2">
                                  {{ serv.Name }}
                                </span>
                              </div>
                              <template v-slot:actions>
                                <v-icon color="primary"> $expand </v-icon>
                              </template>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <v-virtual-scroll
                                :items="serv.Type"
                                :item-height="80"
                                height="550"
                              >
                                <template v-slot:default="{ item }">
                                  <v-list>
                                    <v-divider :key="item._id"></v-divider>
                                    <v-list-item class="my-3 project">
                                      <!-- <v-list-item-action>
                                                                              <v-checkbox
                                                                                  @click="selectMarAndAdl(item._id)" :input-value="isSelectedMarAndAdl(item._id)"
                                                                                  :disabled="item.Signed === false"
                                                                                  color="success"
                                                                              ></v-checkbox>
                                                                            </v-list-item-action> -->
                                      <v-list-item-content class="ml-n2">
                                        <v-list-item-title
                                          v-html="item.Type"
                                        ></v-list-item-title>
                                        <v-list-item-title class="caption">
                                          {{ item.Time }}
                                        </v-list-item-title>
                                      </v-list-item-content>
                                      <v-list-item-icon>
                                        <div class="mr-3">
                                          <v-chip
                                            class="ma-2"
                                            small
                                            :color="
                                              item.Signed ? 'green' : 'red'
                                            "
                                            text-color="white"
                                          >
                                            {{
                                              item.Signed
                                                ? "Completed"
                                                : "Incomplete"
                                            }}
                                          </v-chip>
                                        </div>
                                      </v-list-item-icon>
                                    </v-list-item>
                                  </v-list>
                                </template>
                              </v-virtual-scroll>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </template>
                    </v-card>
                  </v-col>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat>
                  <v-row dense>
                    <v-col cols="12" md="12" sm="12">
                      <v-card elevation="0" outlined>
                        <v-card-title class="mx-2 mt-1 mb-1"
                          >MAR
                          <v-btn
                            :to="'/mar/' + clientID"
                            absolute
                            right
                            small
                            class="mt-n1 cyan darken-3 white--text"
                            >View MAR
                          </v-btn>
                        </v-card-title>
                        <v-divider></v-divider>
                        <template v-for="med in clientMAR">
                          <v-expansion-panels :key="med.ClientId">
                            <v-expansion-panel>
                              <v-expansion-panel-header>
                                <div>
                                  <v-avatar size="40">
                                    <v-img :src="med.Image"></v-img>
                                  </v-avatar>
                                  <span class="ml-2">
                                    {{ med.Name }}
                                  </span>
                                </div>
                                <template v-slot:actions>
                                  <v-icon color="primary"> $expand </v-icon>
                                </template>
                              </v-expansion-panel-header>
                              <v-expansion-panel-content>
                                <v-virtual-scroll
                                  :items="med.Type"
                                  :item-height="80"
                                  height="550"
                                >
                                  <template v-slot:default="{ item }">
                                    <v-list>
                                      <v-divider :key="item._id"></v-divider>
                                      <v-list-item class="my-3 project">
                                        <!-- <v-list-item-action>
                                                                                  <v-checkbox
                                                                                      @click="selectMarAndAdl(item._id)" :input-value="isSelectedMarAndAdl(item._id)"
                                                                                      :disabled="item.Signed === false"
                                                                                      color="success"
                                                                                  ></v-checkbox>
                                                                                </v-list-item-action> -->
                                        <v-list-item-content class="ml-n2">
                                          <v-list-item-title
                                            v-html="item.Type"
                                          ></v-list-item-title>
                                          <v-list-item-title class="caption">
                                            {{ item.Time }}
                                          </v-list-item-title>
                                        </v-list-item-content>
                                        <v-list-item-icon>
                                          <div class="mr-3">
                                            <v-chip
                                              class="ma-2"
                                              small
                                              :color="
                                                item.Signed ? 'green' : 'red'
                                              "
                                              text-color="white"
                                            >
                                              {{
                                                item.Signed
                                                  ? "Completed"
                                                  : "Incomplete"
                                              }}
                                            </v-chip>
                                          </div>
                                        </v-list-item-icon>
                                      </v-list-item>
                                    </v-list>
                                  </template>
                                </v-virtual-scroll>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </template>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="checklistDialog = false">
            Disagree
          </v-btn>
          <v-btn color="green darken-1" text @click="getIncompleIds()">
            Agree
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="scheduleDialogForClockIn" persistent max-width="900">
      <v-card>
        <v-toolbar color="primary" dark class="text-h5"> Shift </v-toolbar>
        <v-card-text>
          <v-card>
            <v-card flat>
              <v-col cols="12" md="12" sm="12">
                <v-card elevation="0" outlined>
                  <v-list>
                    <v-divider></v-divider>
                    <v-list-item
                      v-for="shift in scheduleShift"
                      :key="shift.counter"
                      router
                      :to="shift.route"
                    >
                      <v-list-item-action>
                        <v-checkbox
                          multiple
                          v-model="selectedShiftForClockIn"
                          :value="shift._id"
                        ></v-checkbox>
                      </v-list-item-action>

                      <v-list-item-avatar size="24">
                        <v-icon
                          small
                          :class="[shift.iconClass]"
                          v-text="shift.icon"
                        ></v-icon>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title v-text="shift.title">
                        </v-list-item-title>
                        <v-list-item-subtitle
                          v-text="shift.subtitle"
                        ></v-list-item-subtitle>
                      </v-list-item-content>

                      <v-tooltip right>
                        <template v-slot:activator="{ on, attrs }">
                          <v-list-item-action>
                            <v-btn icon v-on="on" v-bind="attrs">
                              <v-icon color="red lighten-1"
                                >mdi-information</v-icon
                              >
                            </v-btn>
                          </v-list-item-action>
                        </template>
                        <span>{{ shift.Name }}</span
                        ><br />
                        <span class="font-weight-light"
                          ><!--PUT SOMETHING HERE--></span
                        >
                      </v-tooltip>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-col>
            </v-card>
          </v-card>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="scheduleDialogForClockIn = false"
          >
            Cancel
          </v-btn>
          <v-btn color="green darken-1" text @click="clockInShift()">
            Clock In
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="scheduleDialogForClockOut" persistent max-width="900">
      <v-card>
        <v-toolbar color="primary" dark class="text-h5">
          Upcoming Shift
        </v-toolbar>
        <v-card-text>
          <v-card>
            <v-card flat>
              <v-col cols="12" md="12" sm="12">
                <v-card elevation="0" outlined>
                  <v-list>
                    <v-divider></v-divider>
                    <v-list-item
                      v-for="shift in scheduleShiftForClockOut"
                      :key="shift._id"
                      router
                      :to="shift.route"
                    >
                      <v-list-item-action>
                        <v-checkbox
                          multiple
                          v-model="selectedScheduleForClockOut"
                          :value="shift._id"
                        ></v-checkbox>
                      </v-list-item-action>

                      <v-list-item-avatar size="24">
                        <v-icon
                          small
                          :class="[shift.iconClass]"
                          v-text="shift.icon"
                        ></v-icon>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title
                          v-text="shift.title"
                        ></v-list-item-title>
                        <v-list-item-subtitle
                          v-text="shift.subtitle"
                        ></v-list-item-subtitle>
                      </v-list-item-content>

                      <v-tooltip right>
                        <template v-slot:activator="{ on, attrs }">
                          <v-list-item-action>
                            <v-btn icon v-on="on" v-bind="attrs">
                              <v-icon color="red lighten-1"
                                >mdi-information</v-icon
                              >
                            </v-btn>
                          </v-list-item-action>
                        </template>
                        <span>{{ shift.Name }}</span>
                        <br />
                        <span class="font-weight-light"
                          ><!--PUT SOMETHING HERE--></span
                        >
                      </v-tooltip>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-col>
            </v-card>
          </v-card>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="scheduleDialogForClockOut = false"
          >
            Cancel
          </v-btn>
          <v-btn color="green darken-1" text @click="clockOutShift()">
            Clock Out
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="locationDialog" persistent max-width="500">
      <v-card>
        <v-toolbar color="primary" title="Opening from the top">
          <v-card-title class="text-h6 white--text" color="white">
            Do you acknowledge your location adress?
          </v-card-title>
        </v-toolbar>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <GeoFence
                :initialCenterLat="lat"
                :initialCenterLng="lng"
                :geofenceRadiusFeet="geofenceDistance"
                :programAddress="clientAddress"
                :searchAddress="searchAddress"
                :streetCurrent="street"
                @address-checked="handleAddressChecked"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title>Current Location</v-list-item-title>
                  <v-list-item-subtitle>{{ street }}</v-list-item-subtitle>
                  <v-list-item-subtitle>{{ lat }}</v-list-item-subtitle>
                  <v-list-item-subtitle>{{ lng }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="12" md="6">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title>Program Location</v-list-item-title>
                  <v-list-item-subtitle>{{
                    streetProgram
                  }}</v-list-item-subtitle>
                  <v-list-item-subtitle>{{
                    locationProgram
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
          <!--
                    <v-row>
                        <v-col cols="4">
                            <v-subheader class="align-end text-uppercase font-weight-black">Street :</v-subheader>
                        </v-col>
                        <v-col cols="8">
                            <v-text-field
                                v-model="street"
                                v-if="locationEdit"
                            ></v-text-field>
                            <v-text-field
                                v-model="street"
                                disabled
                                v-else
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">
                            <v-subheader class="align-end text-uppercase font-weight-black">City :</v-subheader>
                        </v-col>
                        <v-col cols="8">
                            <v-text-field
                                v-model="city"
                                v-if="locationEdit"
                            ></v-text-field>
                            <v-text-field
                                v-model="city"
                                disabled
                                v-else
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">
                            <v-subheader class="align-end text-uppercase font-weight-black">Country :</v-subheader>
                        </v-col>
                        <v-col cols="8">
                            <v-text-field
                                v-model="country"
                                v-if="locationEdit"
                            ></v-text-field>
                            <v-text-field
                                v-model="country"
                                disabled
                                v-else
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    -->
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <span v-if="locationEdit">
            <v-btn color="green darken-1" text @click="getAllUpcomingShift()">
              Save
            </v-btn>

            <v-btn
              color="green darken-1"
              text
              @click="locationEdit = !locationEdit"
            >
              Cancel
            </v-btn>
          </span>
          <span v-else>
            <!--REMOVE FOR NOW
            <v-btn color="green darken-1" text @click="locationEdit = !locationEdit">
              Edit
            </v-btn>
            -->
            <v-btn
              color="red darken-1"
              text
              @click="locationDialog = !locationDialog"
            >
              Close
            </v-btn>
            <v-btn
              v-if="inGeofenceLimit"
              color="green darken-1"
              text
              @click="getAllUpcomingShift()"
            >
              Proceed
            </v-btn>
          </span>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- task v-dialog -->
    <v-dialog v-model="taskDialog" max-width="100%">
      <v-card>
        <v-card-title style="background-color: #2b3990" class="white--text">
          <span class="headline">{{ titleForm }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form">
              <v-row>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field
                    v-model="newTitle"
                    label="Task Title"
                    :rules="requiredRules"
                  ></v-text-field>
                </v-col>
                <v-col class="d-flex" cols="12" sm="12" md="4">
                  <v-select
                    :items="dstatus"
                    label="Status"
                    v-model="newStatus"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field
                    label="Assigned To"
                    v-model="newAssigned.Name"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12">
                  <v-textarea
                    label="Description"
                    v-model="newDescription"
                    auto-grow
                    outlined
                    rows="5"
                    row-height="15"
                    :rules="requiredRules"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" sm="6">
                  <!-- <v-menu>
                                      <template v-slot:activator="{ on }">
                                      <v-text-field :value="dueDate" label="Task Due Date" prepend-icon="date_range" v-on="on" :rules="requiredRules"></v-text-field>
                                      </template>
                                      <v-date-picker v-model="dueDate"></v-date-picker>
                                    </v-menu> -->
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="true"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dueDate"
                        label="Task Due Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="dueDate" no-title scrollable>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    label="Date Created"
                    readonly
                    v-model="newDateCreated"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="white--text" color="#259647" @click="complete(taskID)"
            >Complete
          </v-btn>
          <!-- <v-btn color="blue darken-1" text @click="updateTask()" v-if="editLead">Update</v-btn
                    > -->
          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/* eslint-disable */

import StaffNav from "../components/StaffNav";
import StaffSide from "../components/StaffSide";
import ConfirmationDialog from "../components/shared/ConfirmationDialog";
import Foot from "../components/Footer.vue";
import axios from "axios";
import moment from "moment";
import { datetime, RRule } from "rrule";

//import { quest_api } from '../client_config/config';
import { setUserTz } from "../../utils/timezone";

const url = require("../client_config/config").url;
const quest_url = require("../client_config/config").quest_url;
const quest_api = require("../client_config/config").quest_api;
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import Swal from "sweetalert2";
import DateTimeUtil from "../../utils/date-time.util";
import GeoFence from "../components/GeoFence.vue";

export default {
  components: {
    StaffNav,
    StaffSide,
    Foot,
    ConfirmationDialog,
    GeoFence,
  },
  props: ["empID"],
  data: () => ({
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    menu: false,
    value: 0,
    query: false,
    show: true,
    interval: 0,
    employees: [],
    tasks: [],
    clients: [],
    unitProgram: [],
    marTasks: [],
    adlTasks: [],
    taskToApprove: [],
    selectedShiftForClockIn: "",
    selectedScheduleForClockOut: "",
    clientID: "",
    houseID: "",
    houseManager: "",
    selectedIds: [],
    incompleteIds: [],
    page: "main",
    clientMAR: [],
    clientADL: [],
    headers: [
      { text: "Schedule Date", value: "ScheduleDate" },
      {
        text: "Clocked In Date",
        align: "start",
        sortable: false,
        value: "date",
      },
      { text: "Clocked In", value: "clockin" },
      { text: "Clocked Out", value: "clockout" },
      { text: "Total Hours", value: "totalHour" },
      { text: "Location IN", value: "locationLogin" },
      { text: "Location OUT", value: "locationLogout" },
      { text: "Client", value: "client" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    dialog: false,
    taskDialog: false,
    editTimeSheet: false,
    newTimeSheet: false,
    staffID: localStorage.getItem("staffId"),
    userID: localStorage.getItem("userID"),
    Role: localStorage.getItem("userRole"),
    color: "",
    msg: false,
    text: "",
    icon: "",
    timeSheets: [],
    status: ["Pending", "Completed", "Overdue"],
    units: ["Daily", "Hourly", "Quarter Hour", "Monthly", "Session"],
    titleForm: "New Time Sheet",
    timeSheetID: "",
    newClockIn: "",
    newClockOut: "",
    editedIndex: -1,
    editedItem: {
      clockIn: "",
      clockOut: "",
      totalHours: "",
    },
    defaultItem: {
      clockIn: "",
      clockOut: "",
      totalHours: "",
    },
    isLoading: true,
    updates: [
      {
        icon: "work",
        iconClass: "yellow darken-1 white--text",
        title: "7am - 3pm",
        subtitle: "Jun 20, 2020",
        route: "/",
      },
    ],
    upcomingSchedule: [
      {
        icon: "work",
        iconClass: "yellow darken-1 white--text",
        title: "No Upcoming Schedule Shift",
        subtitle: "",
        route: "/",
      },
    ],
    scheduleShift: [
      {
        icon: "work",
        iconClass: "yellow darken-1 white--text",
        title: "No Upcoming Schedule Shift",
        subtitle: "",
        route: "/",
      },
    ],
    scheduleShiftForClockOut: [
      {
        icon: "work",
        iconClass: "yellow darken-1 white--text",
        title: "No Upcoming Schedule Shift",
        subtitle: "",
        route: "/",
      },
    ],
    lat: "",
    lng: "",
    street: "",
    city: "",
    country: "",
    zip: "",
    streetProgram: "",
    locationProgram: "",
    lngProgram: "",
    latProgram: "",
    totalWeeklyHour: 0,
    onShift: false,
    checklistDialog: false,
    scheduleDialogForClockIn: false,
    scheduleDialogForClockOut: false,
    tab: null,
    currentTimesheetID: "",
    titleDialog: "Confirming...",
    contentDialog: "Do you confirm your CLOCK IN?",
    clientScheduledShift: [],

    shiftsList: [],
    selectedStaffDialog: false,
    selectedStaff: {},
    toUpdate_StartDatetime: new Date(),
    toUpdate_EndDatetime: new Date(
      new Date().setTime(new Date().getTime() + 1 * 60 * 60 * 1000)
    ),
    textFieldProps: {
      appendIcon: "event",
    },
    startDateProps: {
      //min: moment(new Date()).format("YYYY-MM-DD")
    },
    startTimeProps: {
      ampmInTitle: true,
    },
    endDateProps: {
      // min: moment(new Date()).format("YYYY-MM-DD")
    },
    endTimeProps: {
      ampmInTitle: true,
    },
    updateUpcomingDateTime_btn: false,
    isShowUpdateDateTimeBtn: false,
    triggerStaffNavReactiveness: false,

    editTimeClockInOutSnackbar: false,
    editTimeClockInOutSnackbarText: "",

    locationDialog: false,
    locationTitleDialog: "",
    locationContentDialog: "",
    locationEdit: false,
    locationConfirm: false,

    isDisableClockInButton: false,
    isDisableClockOutButton: false,
    newTitle: "",
    newStatus: "",
    newDescription: "",
    newAssigned: "",
    newDateCreated: "",
    dueDate: "",
    taskID: "",
    dstatus: ["New", "Pending", "Overdue", "Completed"],
    requiredRules: [(v) => !!v || "This is required"],
    clientAddress: "",
    searchAddress: "",
    inGeofenceLimit: false,
    setGeoFence: false,
    geofenceDistance: 0,
  }),
  newClock: [],
  newClockID: 0,
  clockOutAvailable: false,
  isAllowedRoles: false,

  computed: {
    ...mapGetters({
      adl: "services/getAllClientServices",
      mar: "medications/getAllClientMedications",
      getUserTimezone: "timezones/getUserTimezone",
      getDefaultTz: "timezones/getDefaultTz",
    }),

    ...mapState("timesheet", {
      allowAccessAction: "allowAccessAction",
    }),

    userTimezone() {
      const data = {
        userTimezone: this.getUserTimezone,
        defaultTz: this.getDefaultTz,
      };
      return setUserTz(data);
    },

    formTitle() {
      return this.editedIndex != 1 ? "New Item" : "Edit Item";
    },
    sortedItem() {
      return {
        mar: this.sortItem(this.mar.filter((item) => item != undefined)),
        adl: this.sortItem(this.adl),
      };
    },
    size() {
      const size = {
        xs: "small",
        sm: "large",
        lg: "large",
        xl: "x-large",
      }[this.$vuetify.breakpoint.name];
      return size ? { [size]: true } : {};
    },
  },

  watch: {
    dialog(val) {
      //val || this.close();
      console.log(val);
    },

    selectedStaffDialog(val) {
      !val ? (this.selectedStaff = {}) : this.selectedStaff;
    },

    // toUpdate_StartDatetime (val) {
    //   this.toUpdate_EndDatetime = new Date(
    //     new Date().setTime(val.getTime() + 8 * 60 * 60 * 1000)
    //   );
    // },
  },

  mounted() {
    this.queryAndIndeterminate();
    this.allowedRoles();
    //this.geoFindMe();
    //this.getCurrentLocation();
  },

  beforeDestroy() {
    clearInterval(this.interval);
  },

  async created() {
    this.staffID = this.$route.params.employeeID;
    // this.staffID = localStorage.getItem('staffId');
    await this.getEmployees(this.staffID);
    await this.getTasks(this.staffID);
    await this.getTimeSheets();
    await this.getUpcomingShift();
    await this.getShiftForClockOut();
    // this.getClients(this.staffID);
    //this.getCurrentLocation();
    //get user's coordinates from browser request
    await this.showUpdateDateTimeBtn();
  },

  methods: {
    queryAndIndeterminate() {
      this.query = true;
      this.value = 0;

      setTimeout(() => {
        this.query = false;

        this.interval = setInterval(() => {
          if (this.value === 100) {
            clearInterval(this.interval);
            this.show = false;
            return setTimeout(this.queryAndIndeterminate, 1000);
          }
          this.value += 25;
        }, 1000);
      }, 2000);
    },
    ...mapActions({
      fetchAllClientServices: "services/fetchAllClientServices",
      fetchAllClientMedications: "medications/fetchAllClientMedications",
      getAllClientsMeds: "medications/getAllClientsMeds",
      getAllClientsServs: "services/getAllClientsServs",
    }),

    ...mapMutations({
      setConfirmedDialog: "SET_CONFIRMED_DIALOG_COMMON",
    }),

    async geoFindMe() {
      if (!navigator.geolocation) {
        console.log("Geolocation is not supported by your browser");
      } else {
        navigator.geolocation.watchPosition(
          this.getSuccessGeolocation,
          this.getErrorGeolocation,
          {
            enableHighAccuracy: true,
            timeout: 0,
            maximumAge: 0,
          }
        );
      }
    },

    async getSuccessGeolocation(position) {
      this.lat = position.coords.latitude;
      this.lng = position.coords.longitude;
    },

    inputDate(data) {
      console.log("INPUT" + data);
    },

    getErrorGeolocation(error) {
      console.log(error);
    },

    initialize() {
      this.timeSheets = [];
      this.newClock = [];
      this.newClockID = 0;
      this.taskToApprove = [];
    },

    viewTask(item) {
      this.taskDialog = true;
      this.newTitle = item.Title;
      this.newStatus = item.Status;
      this.newDescription = item.Description;
      this.newAssigned = item.Staff;
      this.dueDate = item.DueDate;
      this.newDateCreated = item.CreatedDate;
      this.taskID = item._id;
      this.updateTask();
    },

    updateTask() {
      var req_body = {
        Status: "Pending",
      };

      axios.put(`${url}/tasks/${this.taskID}`, req_body).then((response) => {
        // this.getTasks();
        if (response.status == 400) {
          response.json().then(function (data) {
            alert(data.msg);
          });
        }
      });
    },

    async getCurrentLocation() {
      try {
        const location = await this.$getLocation({
          enableHighAccuracy: true,
          timeout: Infinity,
          maximumAge: 0,
        });
        this.lat = location.lat;
        this.lng = location.lng;
        return true;
      } catch (error) {
        console.log(error);
        // Show the "Print in progress" modal
        Swal.fire({
          title: "Error",
          text: "Location access was denied. Please enable it in your browser settings or mobile settings.",
          icon: "warning",
          allowOutsideClick: true,
          allowEscapeKey: true,
          showCancelButton: false,
          showConfirmButton: true,
          confirmButtonText: "Close",
        });
        return false;
      }
    },

    reactiveTimesheetTable(val) {
      val ? this.getTimeSheets() : val;
    },

    viewTimeSheet(item) {
      this.newClockOut = null;
      this.clockOutAvailable = false;
      this.newClock = [];
      this.newClockID = 0;
      this.titleForm = "Viewing Time";
      this.dialog = true;
      this.editTimeSheet = true;
      this.newTimeSheet = false;
      this.newClockIn = moment(new Date(item.ClockIn)).format(
        "YYYY-MM-DD hh:mm a"
      ); //First item is clockin time
      this.newClock.push(item.ClockIn);
      this.newClockID = item._id;
      if (item.ClockOut == "") {
        this.newClockOut = null;
      } else {
        this.clockOutAvailable = true;
        this.newClockOut = moment(new Date(item.ClockOut)).format(
          "YYYY-MM-DD hh:mm a"
        ); //second item is clockout time
        this.newClock.push(item.ClockOut);
      }
    },

    showAdd() {
      this.titleForm = "New Time Sheet";
      this.newTimeSheet = true;
      this.editTimeSheet = false;
    },

    deleteTimeSheet(item) {
      const timesheetID = item._id;
      const response = confirm(
        "Are you sure you want to delete this time sheet entry?"
      );

      if (response == true) {
        if (timesheetID != null) this.timeSheetDelete(timesheetID);
      }
    },

    timeSheetDelete(id) {
      axios
        .delete(`${url}/timeSheets/${id}`)
        .then((response) => {
          this.getTimeSheets();
          if (response.status == 400) {
            response.json().then(function (data) {
              return data.msg;
            });
          }
          this.msg = true;
          this.text = "The time sheet entry has been deleted successfully.";
          this.getUpcomingShift();
        })
        .finally(() => {
          this.triggerStaffNavReactiveness = true;
          setTimeout(() => (this.triggerStaffNavReactiveness = false), 3000);
        });
    },
    close() {
      this.dialog = false;
      this.taskDialog = false;
    },
    closeUpdateTimeSheet() {
      this.dialog = false;
      this.$refs.childref.clearHandler(); //CLEAR DATETIMEVALUE
    },
    callUpdates() {
      let ClockOut = "";
      const ClockIn = moment(new Date(this.newClockIn))
        .utc()
        .format("YYYY-MM-DD hh:mm a");
      if (this.newClockOut !== "" && this.newClockOut !== null) {
        ClockOut = moment(new Date(this.newClockOut))
          .utc()
          .format("YYYY-MM-DD hh:mm a");
      }

      let getHours = moment
        .duration(moment(new Date(ClockOut)).diff(moment(new Date(ClockIn))))
        .asHours(); // check if clock-out is less than clock-in.
      let getDate = moment(new Date(ClockIn)).format("YYYY-MM-DD"); // to check if date is 1970-01-01 or date displayed by no clock-in input.

      if (ClockIn != "Invalid Date" && ClockOut == "") {
        var req_body = {
          ClockIn: ClockIn,
          timesheetID: this.newClockID,
        };
        this.updateTimeSheet(req_body);
      } else if (
        ClockIn != "Invalid Date" &&
        getDate != "1970-01-01" &&
        ClockOut != "" &&
        ClockOut != null &&
        // ClockOut > ClockIn
        getHours > 0
      ) {
        var req_body = {
          ClockIn: ClockIn,
          ClockOut: ClockOut,
          timesheetID: this.newClockID,
        };
        this.updateTimeSheet(req_body);
      } else if (this.newClockIn == null || this.newClockOut == null) {
        let text = "";

        if (this.newClockIn == null) {
          text = "Please input Clock In.";
        } else if (this.newClockOut == null) {
          text = "Please input Clock Out.";
        } else if (this.newClockIn == null && this.newClockOut == null) {
          text = "Please input Clock In and Clock Out.";
        }

        this.msg = true;
        this.text = text;
        this.color = "error";
      } else {
        // Give out proper prompt
        // alert("Invalid Dates placed.");
        this.msg = true;
        this.text =
          "Invalid Dates placed. Clock-out should not be less than Clock-in time.";
        this.color = "error";
      }
    },

    updateTimeSheet(req_body) {
      axios
        .put(`${url}/timeSheets/${req_body.timesheetID}`, req_body)
        .then((response) => {
          this.getTimeSheets();
          if (response.status == 400) {
            response.json().then(function (data) {
              alert(data.msg);
            });
          }
          this.newClockIn = "";
          this.newClockOut = "";
          this.msg = true;
          this.text = "The time sheet has been updated successfully.";
          this.color = "success";
        })
        .finally(() => {
          this.triggerStaffNavReactiveness = true;
          setTimeout(() => (this.triggerStaffNavReactiveness = false), 3000);
        });
      this.closeUpdateTimeSheet();
    },

    getEmployees(id) {
      axios.get(`${url}/employees/${id}`).then((res) => {
        this.employees = res.data.employee;
      });
    },

    getTimeSheets: function () {
      this.isLoading = true;
      let employeeID = this.staffID;
      axios
        .get(`${url}/timeSheets/${employeeID}`)
        .then((res) => {
          this.timeSheets = [];

          let dateNowUTC = moment.utc(new Date()).format("YYYY-MM-DD");
          res.data.timeSheet.forEach((value) => {
            let clockinFull = "";
            // let clockoutFull = "";
            let totalTimeFull = "";
            let dateClockInUTC = moment
              .utc(new Date(value.ClockIn))
              .format("YYYY-MM-DD");

            value.ScheduleDate = moment(new Date(value.ClockInSchedule))
              .tz(this.userTimezone)
              .format("YYYY-MM-DD");

            value.ClockIn = value.ClockIn === undefined ? "" : value.ClockIn;
            value.ClockOut = value.ClockOut === undefined ? "" : value.ClockOut;

            value.date = moment(new Date(value.ClockIn))
              .tz(this.userTimezone)
              .format("YYYY-MM-DD");
            value.clockin =
              value.ClockIn === ""
                ? "- -"
                : moment(new Date(value.ClockIn)).format("hh:mm a");
            clockinFull = moment(new Date(value.ClockIn));

            //SET TIMESHEET ID TO USE FOR LOGOUT
            if (dateNowUTC === dateClockInUTC && value.ClockOut === "") {
              this.currentTimesheetID = value._id;
            }

            //geolocation
            if (value && value.GeolocationIn && value.GeolocationIn.length) {
              value.GeolocationIn.forEach((val) => {
                value.locationLogin =
                  val["Street"] + ", " + val["City"] + ", " + val["Country"];
              });
            }

            if (value.Late !== undefined && value.Late > 0) {
              value.ClockInStatus = "LATE";
            }

            value.clockout =
              value.ClockOut === ""
                ? "- -"
                : moment(new Date(value.ClockOut)).format("hh:mm a");

            // clockoutFull = moment(new Date(value.ClockOut));

            //geolocation out
            if (value && value.GeolocationOut && value.GeolocationOut.length) {
              value.GeolocationOut.forEach((val) => {
                value.locationLogout =
                  val["Street"] + ", " + val["City"] + ", " + val["Country"];
              });
            }

            if (value.ClockOut === "") {
              totalTimeFull = clockinFull.diff(clockinFull);
            } else {
              const clockinFull = moment(
                new Date(`${value.date} ${value.clockin}`),
                "YYYY-MM-DD HH:mm"
              );
              const clockoutFull = moment(
                new Date(`${value.date} ${value.clockout}`),
                "YYYY-MM-DD HH:mm"
              );

              totalTimeFull = clockoutFull.diff(clockinFull);

              /*
              document.querySelector(
                ".timeFullHere"
              ).innerHTML += `<p>${totalTimeFull}</p>`;
              */

              if (totalTimeFull < 0) {
                totalTimeFull = moment(new Date(clockoutFull))
                  .add(1, "days")
                  .diff(clockinFull);
              }
            }

            let duration = moment.duration(totalTimeFull);

            // console.log(duration);

            let hours = duration.hours();
            let minutes = duration.minutes();

            let totaltime = `${hours}h ${minutes}m`;

            value.totalHour = totaltime;
            this.totalWeeklyHour =
              parseFloat(this.totalWeeklyHour) +
              parseFloat(Math.floor(minutes));

            let clientName = "";
            value.clients.forEach((val, index) => {
              if (index === value.clients.length - 1) {
                clientName += val.Name;
              } else {
                clientName += val.Name + ", ";
              }
            });

            value.client = clientName;

            this.timeSheets.push(value);
          });
        })
        .finally(() => (this.isLoading = false));
    },

    addTimeSheet: function () {
      var req_body = {
        ClockIn: this.newClockIn,
        ClockOut: this.newClockOut,
      };

      axios.post(`${url}/timeSheets`, req_body).then((res) => {
        this.getTimeSheets();
        if (res.status === 400) {
          res.json().then(function (data) {
            this.text = data.msg;
          });
        }
        this.newClockIn = "";
        this.newClockOut = "";
        this.msg = true;
        this.text = "The new time sheet has been added successfully.";
      });
      this.close();
    },

    confirmClockIn() {
      this.setConfirmedDialog(true);
    },

    checkTimeSheet(schedule) {
      return this.timeSheets.filter(
        (timesheet) =>
          schedule._id === timesheet.Shift &&
          schedule.clockInScheduleDate === timesheet.date
      );
    },

    handleAddressChecked(result) {
      console.log(result);
      this.locationProgram = result.location;
      if (this.setGeoFence) {
        this.inGeofenceLimit = result.isWithinGeofence;
      } else {
        this.inGeofenceLimit = true;
      }
    },

    async confirmLocationClockIn() {
      this.setConfirmedDialog(false);
      let dateNow = moment(new Date()).format("YYYY-MM-DD");
      let dateYesterday = moment(new Date())
        .subtract(1, "days")
        .format("YYYY-MM-DD");

      const todaySchedule = this.scheduleShift.filter(
        (schedule) =>
          moment(dateNow).isSame(schedule.clockInScheduleDate) ||
          (moment(dateNow).isSame(schedule.clockOutSchedule) &&
            moment(dateYesterday).isSame(schedule.clockInScheduleDate))
      );

      this.setGeoFence = todaySchedule[0]?.SetGeofence;
      this.geofenceDistance = todaySchedule[0]?.SetGeofenceDistance;
      this.clientAddress = todaySchedule[0]?.unitAddress;
      this.searchAddress = todaySchedule[0]?.SearchAddress;
      this.streetProgram = todaySchedule[0]?.unitAddress;

      // Show the "Print in progress" modal
      Swal.fire({
        title: "ClockIn in Progress",
        text: "Please wait while processsing your request. This may take a while.",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCancelButton: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const getLocation = await this.getCurrentLocation();

      if (getLocation) {
        await this.getLatLang(this.lat, this.lng);
        this.locationDialog = true;
        Swal.close();
      }
    },

    getAllUpcomingShift() {
      this.locationDialog = false;
      let dateNow = moment(new Date()).format("YYYY-MM-DD");
      let dateYesterday = moment(new Date())
        .subtract(1, "days")
        .format("YYYY-MM-DD");

      let scheduleFinal = [];

      const todaySchedule = this.scheduleShift.filter(
        (schedule) =>
          moment(dateNow).isSame(schedule.clockInScheduleDate) ||
          (moment(dateNow).isSame(schedule.clockOutSchedule) &&
            moment(dateYesterday).isSame(schedule.clockInScheduleDate))
      );

      todaySchedule.forEach((schedule) => {
        if (this.checkTimeSheet(schedule).length === 0) {
          scheduleFinal.push(schedule);
        }
      });

      if (scheduleFinal.length === 1) {
        this.clockIn(scheduleFinal[0]);
      } else if (scheduleFinal.length === 0) {
        this.msg = true;
        this.color = "error";
        this.text = "No ClockIn Schedule.";
      } else {
        this.scheduleShift = scheduleFinal;
        this.scheduleDialogForClockIn = true;
      }
    },

    clockInShift() {
      this.selectedShiftForClockIn.forEach((scheduleId) => {
        this.scheduleShift.filter((schedule) => {
          if (schedule._id === scheduleId) {
            this.clockIn(schedule);
          }
        });
      });
    },

    clockIn: async function (schedule) {
      const ClientID = await schedule.ClientId.map((item) => {
        return item._id;
      });

      let clockInSchedule = "",
        clockOutSchedule = "",
        recurringDate = "";

      if (schedule.isReccuring) {
        recurringDate = schedule.clockInScheduleDate;
        clockInSchedule = schedule.clockInSchedule;
        clockOutSchedule = schedule.clockOutSchedule;
      }

      let userNowDate = moment(new Date()).format("YYYY-MM-DD");

      var req_body = {
        ScheduleId: schedule._id,
        EmployeeId: this.staffID,
        Lat: this.lat,
        Lng: this.lng,
        Country: this.country,
        Street: this.street,
        City: this.city,
        Zip: this.zip,
        UserNowDate: userNowDate,
        RecurringDate: recurringDate,
        ClockInSchedule: clockInSchedule,
        ClockOutSchedule: clockOutSchedule,
        ClientId: ClientID,
        Program: schedule.Program,
      };

      await axios
        .post(`${url}/timeSheets/clockin`, req_body)
        .then((res) => {
          if (res) {
            this.msg = true;
            this.color = "success";
            this.text = "Clockin successfully.";
            this.getTimeSheets();
          }
        })
        .catch((err) => {
          this.msg = true;
          this.text = err.response.data.msg;
          this.color = "error";
          this.onShift = true;
        })
        .finally(() => {
          this.triggerStaffNavReactiveness = true;
          setTimeout(() => (this.triggerStaffNavReactiveness = false), 3000);
        });
      //this.close();
      this.scheduleDialogForClockIn = false;
      this.getShiftForClockOut();
      this.getUpcomingShift();
    },

    async getMARADL() {
      let clientIds = [];
      for (let i = 0; i < this.clientScheduledShift.length; i++) {
        if (this.clientScheduledShift[i].ClientId.length > 0) {
          this.clientID = this.clientScheduledShift[i].ClientId;
          this.houseID = this.clientScheduledShift[i].HouseId;
          this.clientID.map((item) => {
            clientIds.push(item._id);
          });
        }
      }
      try {
        if (clientIds.length !== 0) {
          const responseMAR = await this.getAllClientsMeds(clientIds);
          const responseADL = await this.getAllClientsServs(clientIds);
          this.clientMAR = this.createList(responseMAR.medications, "mar");
          this.clientADL = this.createList(responseADL.services, "adl");
        }
      } catch (error) {
        console.log(error);
      }
    },

    createList(data, type) {
      let groupedData = {};
      data.forEach((obj) => {
        const { ClientID, client, ...itemData } = obj;

        let typeData = {
          _id: itemData._id,
          Type:
            type === "mar"
              ? itemData.Medication
              : `${itemData.Type} - ${itemData.ServiceItem}`,
          Time: type === "mar" ? itemData.AdminTime : itemData.ScheduledTime,
          Signed: itemData.Signed,
        };

        if (groupedData[ClientID]) {
          groupedData[ClientID].Type.push(typeData);
        } else {
          groupedData[ClientID] = {
            ClientId: ClientID,
            Name: client.Name,
            Image: client.Image,
            Type: [typeData],
          };
        }
      });
      return Object.values(groupedData);
    },

    showCheckDialogForClockOut() {
      this.getMARADL();

      if (this.scheduleShiftForClockOut.length === 0) {
        this.msg = true;
        this.text = "No Schedule Found.";
        this.color = "error";
      } else {
        this.checklistDialog = true;
      }
    },

    clockOutShift() {
      if (this.selectedScheduleForClockOut.length > 0) {
        this.selectedScheduleForClockOut.forEach((scheduleId) => {
          this.scheduleShiftForClockOut.filter((schedule) => {
            if (schedule._id === scheduleId) {
              this.clockOut(schedule);
            }
          });
        });
      } else {
        this.msg = true;
        this.text = "No Schedule Selected.";
        this.color = "error";
      }
    },

    clockOut: async function (schedule) {
      let recurringDate = schedule.isReccuring ? schedule.clockOutSchedule : "";

      const getLocation = await this.getCurrentLocation();

      if (getLocation) {
        await this.getLatLang(this.lat, this.lng);
      }

      let userNowDate = moment(new Date()).format("YYYY-MM-DD");

      var req_body = {
        ScheduleId: schedule.scheduleId,
        EmployeeId: localStorage.getItem("staffId"),
        Lat: this.lat,
        Lng: this.lng,
        Country: this.country,
        Street: this.street,
        City: this.city,
        Zip: this.zip,
        TimesheetID: schedule._id,
        UserNowDate: userNowDate,
        RecurringDate: recurringDate,
      };

      await axios
        .post(`${url}/timeSheets/clockout`, req_body)
        .then((res) => {
          if (res) {
            this.msg = true;
            this.color = "success";
            this.text = "Clock Out successfully.";
            this.getTimeSheets();
          }
        })
        .catch((err) => {
          this.msg = true;
          this.text = err.response.data.msg;
          this.color = "error";
        })
        .finally(() => {
          this.triggerStaffNavReactiveness = true;
          setTimeout(() => (this.triggerStaffNavReactiveness = false), 3000);
        });
      this.close();
      this.scheduleDialogForClockOut = false;
      this.getShiftForClockOut();
    },

    async getUpcomingShift() {
      this.scheduleShift = [];
      this.upcomingSchedule = [];
      let dataRecurring = [];

      await axios
        .get(`${url}/shifts/upcoming`, {
          params: {
            EmployeeId: this.staffID,
            Timezone: this.userTimezone,
          },
        })
        .then((response) => {
          let counter = 0;
          let dateNow = moment(new Date());

          console.log(response.data);

          response.data.shifts.forEach((item) => {
            const { users, clients, units } = item;
            if (clients.length > 0) {
              item.clientName = clients
                .map((client) => client.Name)
                .reduce((a, b) => {
                  return `${a}, ${b}`;
                });
            } else {
              item.clientName = "";
            }
            item.Name = users?.Name || "";

            let StartDate = item.StartDate;
            let EndDate = item.EndDate;

            if (item.isRecurringEvent === "Yes") {
              const recurringYear = moment(StartDate).utc().year();
              const recurringMonth = moment(StartDate).utc().format("M");
              const recurringDay = moment(StartDate).utc().format("D");
              const recurringHour = moment(StartDate).utc().format("HH");
              const recurringMinute = moment(StartDate).utc().format("mm");

              const recurringEndYear = moment(EndDate).utc().year();
              const recurringEndMonth = moment(EndDate).utc().format("M");
              const recurringEndDay = moment(EndDate).utc().format("D");
              const recurringEndHour = moment(EndDate).utc().format("HH");
              const recurringEndMinute = moment(EndDate).utc().format("mm");

              const recurringTypeSwitch = (eventType) =>
                ({
                  Daily: RRule.DAILY,
                  Weekly: RRule.WEEKLY,
                  Monthly: RRule.MONTHLY,
                  Annually: RRule.YEARLY,
                }[eventType]);

              const recurringDate = new RRule({
                freq: recurringTypeSwitch(item.typeOfRecurringEvent),
                dtstart: datetime(
                  parseInt(recurringYear),
                  parseInt(recurringMonth),
                  parseInt(recurringDay),
                  parseInt(recurringHour),
                  parseInt(recurringMinute)
                ),
                until: datetime(
                  parseInt(recurringEndYear),
                  parseInt(recurringEndMonth),
                  parseInt(recurringEndDay),
                  parseInt(recurringEndHour),
                  parseInt(recurringEndMinute)
                ),
                interval: 1,
              });

              const dateRec = recurringDate
                .all()
                .map((date) => moment(date).format("MMM D YYYY"));

              dateRec.forEach((itemDate) => {
                if (
                  moment(itemDate).format("YYYY-MM-DD") >=
                  moment(dateNow).format("YYYY-MM-DD")
                ) {
                  let startTime = moment(new Date(item.StartDate)).format(
                    "hh:mm a"
                  );
                  let endTime = moment(new Date(item.EndDate)).format(
                    "hh:mm a"
                  );
                  let timeStart = moment(item.StartDate).format("HH:mm");
                  let timeEnd = moment(item.EndDate).format("HH:mm");
                  let newDate = moment(itemDate).format("YYYY-MM-DD");
                  let newStartDate = moment(
                    newDate + " " + timeStart,
                    "YYYY-MM-DD HH:mm"
                  ).format("YYYY-MM-DD HH:mm");
                  let newEndDate = "";

                  if (timeEnd < timeStart) {
                    newDate = moment(newDate)
                      .add(1, "days")
                      .format("YYYY-MM-DD");
                  }

                  newEndDate = moment(
                    newDate + " " + timeEnd,
                    "YYYY-MM-DD HH:mm"
                  ).format("YYYY-MM-DD HH:mm");

                  dataRecurring.push({
                    icon: "work",
                    iconClass: "yellow darken-1 white--text",
                    title: `${startTime} - ${endTime}`,
                    counter: counter++,
                    subtitle: moment(newStartDate).format("MMM D YYYY"),
                    clientName: item.clientName,
                    Name: item.Name,
                    _id: item._id,
                    clockInScheduleDate:
                      moment(newStartDate).format("YYYY-MM-DD"),
                    clockInSchedule: newStartDate,
                    clockOutSchedule: newEndDate,
                    isReccuring: true,
                    ClientId: clients,
                    Program: units._id,
                    unitLocation: units.Location,
                    unitAddress: units.Address,
                    ProgramName: units.Name,
                    Start: moment(new Date(item.StartDate)).format(
                      "YYYY-MM-DD HH:mm"
                    ),
                    End: moment(new Date(item.EndDate)).format(
                      "YYYY-MM-DD HH:mm"
                    ),
                    Notes: item.Notes,
                    Address:
                      units.Address + ", " + units.State + ", " + units.Zip,
                    SearchAddress: units.Address + ", " + units.City,
                    SetGeofence: item.units?.SetGeofence,
                    SetGeofenceDistance: item.units?.SetGeofenceDistance,
                  });
                }
              });
            } else {
              let startTime = moment(new Date(item.StartDate)).format(
                "hh:mm a"
              );
              let endTime = moment(new Date(item.EndDate)).format("hh:mm a");
              dataRecurring.push({
                iconClass: "yellow darken-1 white--text",
                icon: "work",
                title: `${startTime} - ${endTime}`,
                counter: counter++,
                subtitle: moment(new Date(item.StartDate)).format("MMM D YYYY"),
                clientName: item.clientName,
                Name: item.Name,
                _id: item._id,
                clockInScheduleDate: moment(item.StartDate).format(
                  "YYYY-MM-DD"
                ),
                clockInSchedule: moment(item.StartDate).format("YYYY-MM-DD"),
                clockOutSchedule: moment(item.EndDate).format("YYYY-MM-DD"),
                isReccuring: false,
                ClientId: clients,
                Program: units._id,
                ProgramName: units.Name,
                unitLocation: units.Location,
                unitAddress: units.Address,
                Start: moment(new Date(item.StartDate)).format(
                  "YYYY-MM-DD HH:mm"
                ),
                End: moment(new Date(item.EndDate)).format("YYYY-MM-DD HH:mm"),
                Notes: item.Notes,
                Address: units.Address + ", " + units.State + ", " + units.Zip,
                SearchAddress: units.Address + ", " + units.City,
                SetGeofence: item.units?.SetGeofence,
                SetGeofenceDistance: item.units?.SetGeofenceDistance,
              });
            }
          });
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(async () => {
          this.scheduleShift = dataRecurring;
          this.upcomingSchedule = dataRecurring;

          // console.log({upcomingSchedule: this.upcomingSchedule});

          this.shiftsList = dataRecurring;
          await this.toDisableClockInButton(this.scheduleShift);
        });
    },

    getShiftForClockOut: async function () {
      this.scheduleShiftForClockOut = [];
      let dataRecurring = [];

      try {
        const { data } = await axios.get(
          `${url}/shifts/upcomingShiftForClockOut`,
          {
            params: {
              EmployeeId: this.staffID,
            },
          }
        );

        this.clientScheduledShift = data.shifts;

        let counter = 0;
        let dateNow = moment(new Date());

        data.shifts.forEach((item) => {
          const { Employee, ClientId } = item;

          item.clientName =
            ClientId.length > 0
              ? ClientId.map((client) => client.Name).reduce((a, b) => {
                  return `${a}, ${b}`;
                })
              : "";

          item.Name = Employee?.Name || "";

          let StartDate = item.ClockInSchedule;
          let EndDate = item.ClockOutSchedule;
          let startTime = moment(new Date(StartDate)).format("hh:mm a");
          let endTime = moment(new Date(EndDate)).format("hh:mm a");

          dataRecurring.push({
            iconClass: "yellow darken-1 white--text",
            icon: "work",
            title: `${startTime} - ${endTime}`,
            counter: counter++,
            subtitle: moment(new Date(StartDate)).format("MMM D YYYY"),
            clientName: item.clientName,
            Name: item.Name,
            _id: item._id,
            scheduleId: item.Shift,
            clockInSchedule: moment(StartDate).format("YYYY-MM-DD"),
            clockOutSchedule: moment(EndDate).format("YYYY-MM-DD"),
            isReccuring: false,
          });
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.scheduleShiftForClockOut = dataRecurring;
        await this.toDisableClockOutButton(this.scheduleShiftForClockOut);
      }
    },

    async getLatLang(latitude, longitude) {
      let lat = parseFloat(latitude);
      let lng = parseFloat(longitude);
      let at = lat + "," + lng;
      try {
        const location = await axios.get(
          `${quest_url}key=${quest_api}&location=${at}`,
          { headers: { Authorization: "" } }
        );
        if (location.status === 200) {
          if (location.data.results.length > 0) {
            if (location.data.results[0].locations.length > 0) {
              this.city = location.data.results[0].locations[0].adminArea5;
              this.street =
                location.data.results[0].locations[0].street !== ""
                  ? location.data.results[0].locations[0].street
                  : location.data.results[0].locations[0].adminArea6;
              this.country = location.data.results[0].locations[0].adminArea1;
              this.zip = location.data.results[0].locations[0].postalCode;
            }
          }
          return true;
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    getTasks(id) {
      axios.get(`${url}/tasks/staff/${id}`).then((res) => {
        this.tasks = res.data.tasks;
      });
    },

    complete(id) {
      const response = confirm(
        "Do you acknowledge the completion of this task?"
      );
      if (response == true) {
        var req_body = {
          Status: "Completed",
        };
        axios.put(`${url}/tasks/${id}`, req_body).then((response) => {
          this.getTasks(this.staffID);
          this.msg = true;
          this.text = "The task has been successfully completed";
          this.taskDialog = false;
        });
      }
    },
    approve(id, CompletedTaskId) {
      const response = confirm(
        "Do you acknowledge the completion of this task?"
      );
      if (response == true) {
        var req_body = {
          Status: "Done",
        };
        axios.put(`${url}/tasks/${id}`, req_body).then((response) => {
          this.getTasks(this.staffID);
          if (response.status == 400) {
            response.json().then(function (data) {
              return data.msg;
            });
          }
          this.approveAccomplishTask(CompletedTaskId);
        });
      }
    },
    approveAccomplishTask(id) {
      if (response == true) {
        var req_body = {
          Status: "Approve",
        };
        axios.put(`${url}/tasks/${id}`, req_body).then((response) => {
          this.getTasks(this.staffID);
          if (response.status == 400) {
            response.json().then(function (data) {
              return data.msg;
            });
          }
        });
        this.msg = true;
        this.text = "The task has been successfully completed";
      }
    },
    getStatusColor(status) {
      if (status == "LATE") return "red";
      else return "green";
    },

    sortItem(items) {
      let complete = items.filter((item) => item.Signed === true);
      let incomplete = items.filter((item) => item.Signed === false);

      items.forEach((item) => {
        if (item.Signed === true) {
          this.selectedIds.push(item._id);
        }
      });

      return complete.concat(incomplete);
    },

    isSelectedMarAndAdl(id) {
      let item = "";
      const index = this.selectedIds.indexOf(id);
      if (index > -1) {
        item = this.selectedIds[index];
      }
      return item;
    },

    getIncompleIds() {
      let dateNow = moment(new Date()).format("YYYY-MM-DD");

      const todaySchedule = this.scheduleShiftForClockOut.filter(
        (schedule) =>
          moment(dateNow).isSame(schedule.clockOutSchedule) ||
          moment(dateNow).isSame(schedule.clockInSchedule)
      );

      if (todaySchedule.length == 1) {
        this.clockOut(todaySchedule[0]);
      } else if (todaySchedule.length == 0) {
        this.msg = true;
        this.color = "error";
        this.text = "No Clock Out Schedule.";
      } else {
        this.scheduleShiftForClockOut = todaySchedule;
        this.scheduleDialogForClockOut = true;
      }

      this.adl.forEach((adl) => {
        this.incompleteIds.push(adl._id);
      });
      this.mar.forEach((mar) => {
        this.incompleteIds.push(mar._id);
      });
      if (this.selectedIds.length === 0) {
        this.addIncompleteMarAndAdl();
      } else {
        this.selectedIds.forEach((selectedId) => {
          this.incompleteIds.forEach((incompleteId) => {
            if (selectedId === incompleteId) this.deleteCompleteId(selectedId);
          });
        });
      }
    },
    deleteCompleteId(id) {
      const index = this.incompleteIds.indexOf(id);
      if (index > -1) {
        this.incompleteIds.splice(index, 1);
      }
      this.addIncompleteMarAndAdl();
    },
    addIncompleteMarAndAdl() {
      this.incompleteIds.forEach((incompleteId) => {
        this.mar.forEach((mar) => {
          if (incompleteId === mar._id) {
            this.marTasks.push(mar.Medication);
          }
        });
        this.adl.forEach((adl) => {
          if (incompleteId === adl._id) {
            this.adlTasks.push(adl.ServiceItem);
          }
        });
      });
      this.getHouseManager(this.houseID);
      this.addUnsignedTask();
    },
    addUnsignedTask() {
      let size = this.incompleteIds.length;
      let martitle = this.marTasks.slice(0, 3).map(function (name) {
        return name;
      });
      let adltitle = this.adlTasks.slice(0, 3).map(function (name) {
        return name;
      });
      var req_body = {
        UserId: this.userID,
        Title: "You have" + size + " mar and adl that needs to be signed",
        Description:
          "Mar needs to be signed" +
          " " +
          ' " ' +
          martitle +
          ' " ' +
          " Adl needs to be signed" +
          " " +
          ' " ' +
          adltitle +
          ' " ',
        DesciptionForView:
          "Mar needs to be signed" +
          " " +
          ' " ' +
          this.marTasks +
          ' " ' +
          " Adl needs to be signed" +
          " " +
          ' " ' +
          this.adlTasks +
          ' " ',
        DueDate: moment().format("YYYY-MM-DD"),
        Status: "New",
        Staff: this.userID,
        UrlNotification: this.$router.history.current.path,
      };

      axios.post(`${url}/tasks`, req_body).then((res) => {
        this.getTasks(this.staffID);
        if (res.status == 400) {
          res.json().then(function (data) {
            this.text = data.msg;
          });
        }
        this.newTitle = "";
        this.newDescription = "";
        this.newAssigned = "";
        this.dueDate = "";
        this.msg = true;
        this.text = "The new task has been added successfully.";
      });
      this.checklistDialog = false;
    },

    getHouseManager(id) {
      if (id !== undefined && id !== "") {
        axios.get(`${url}/units/${id}`).then((res) => {
          this.unitProgram = res.data.unit;
          this.houseManager = this.unitProgram.HouseManager;
          this.sendTaskToHousManager();
        });
      }
    },
    sendTaskToHousManager() {
      let martitle = this.marTasks.slice(0, 2).map(function (name) {
        return name;
      });
      let adltitle = this.adlTasks.slice(0, 2).map(function (name) {
        return name;
      });
      var req_body = {
        UserId: this.userID,
        Title: "Follow Up Incomplete MAR and ADL",
        Description:
          "Mar needs to be follow up" +
          " " +
          ' " ' +
          martitle +
          '"' +
          " Adl needs to be follow up" +
          " " +
          adltitle,
        DueDate: "",
        Status: "New",
        Staff: this.houseManager,
        UrlNotification: this.$router.history.current.path,
      };

      axios.post(`${url}/tasks`, req_body).then((res) => {
        this.getTasks(this.staffID);
        if (res.status == 400) {
          res.json().then(function (data) {
            this.text = data.msg;
          });
        }
        this.newTitle = "";
        this.newDescription = "";
        this.newAssigned = "";
        this.dueDate = "";
      });
    },

    // get the selected staff's shift info
    getStaffShift(shift) {
      this.selectedStaffDialog = true;
      this.selectedStaff = shift;

      this.toUpdate_StartDatetime = new Date(this.selectedStaff.Start);
      this.toUpdate_EndDatetime = new Date(this.selectedStaff.End);
    },

    // updates the date/time of upcoming shift
    async updateUpcomingDateTime() {
      // this.updateUpcomingDateTime_btn = true

      if (
        !moment(this.toUpdate_StartDatetime, "YYYY-MM-DD hh:mm A").isAfter(
          moment(this.toUpdate_EndDatetime, "YYYY-MM-DD hh:mm A")
        )
      ) {
        let req_body = {
          toUpdateStartTime: this.toUpdate_StartDatetime,
          toUpdateEndTime: this.toUpdate_EndDatetime,
        };

        await axios
          .post(
            `${url}/shifts/upcoming/updateDateTime/${this.selectedStaff._id}`,
            req_body
          )
          .then((res) => {
            if (res.data.shift.nModified === 1) {
              console.log("Successfully updated");
              this.selectedStaffDialog = false;
              this.getUpcomingShift();
            }
          })
          .catch((error) => {
            console.log(error.response.data.msg);
          })
          .finally(() => (this.updateUpcomingDateTime_btn = false));
      } else {
        this.editTimeClockInOutSnackbar = true;
        this.editTimeClockInOutSnackbarText =
          "Can't Update shift, the date/time start shift is past the date/time end shift.";
      }
    },

    async showUpdateDateTimeBtn() {
      let roles = [
        "Administration",
        "Shift Lead",
        "Assistant Manager",
        "House Manager",
        "Program Manager",
        "Client Services Manager",
        "Medical Manager",
        "Finance Manager",
        "Compliance Manager",
        "Human Resources",
      ];

      this.isShowUpdateDateTimeBtn = roles.includes(this.Role) ? true : false;
    },

    async allowedRoles() {
      let roles = [
        "Administration",
        "Shift Lead",
        "Assistant Manager",
        "House Manager",
        "Program Manager",
        "Client Services Manager",
        "Medical Manager",
        "Finance Manager",
        "Compliance Manager",
        "Human Resources",
      ];

      this.isAllowedRoles = roles.includes(this.Role) ? true : false;
    },

    printCalendar() {
      let startDate = moment().startOf("day");
      startDate = startDate.format("YYYY-MM-DD HH:mm");
      let staff = this.staffID;

      let downloadUrl = `${url}/shifts/print?staffId=${staff}&startDate=${startDate}`;

      // Show the "Print in progress" modal
      Swal.fire({
        title: "Print in Progress",
        text: "Please wait while the PDF is being generated and processed. This may take a while.",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCancelButton: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      // Make a request to the backend API to generate the PDF
      fetch(downloadUrl)
        .then((response) => {
          if (!response.ok) {
            // handle HTTP status code error (like 404 or 500)
            return response.text().then((text) => {
              throw new Error(text || "No schedule found");
            });
          }
          return response.blob();
        })
        .then((blob) => {
          const blobUrl = URL.createObjectURL(blob);
          const printWindow = window.open(blobUrl);

          printWindow.onload = function () {
            // Close the modal when the printing process is complete
            Swal.close();

            printWindow.print();

            URL.revokeObjectURL(blobUrl);
          };
        })
        .catch((error) => {
          console.error("Error:", error);
          Swal.fire("Error", error.message, "error");
        });
    },

    async toDisableClockInButton(schedForClockIn) {
      let dateNow = moment(new Date()).format("YYYY-MM-DD");
      let dateYesterday = moment(new Date())
        .subtract(1, "days")
        .format("YYYY-MM-DD");

      let scheduleFinal = [];

      const todaySchedule = schedForClockIn.filter(
        (schedule) =>
          moment(dateNow).isSame(schedule.clockInScheduleDate) ||
          (moment(dateNow).isSame(schedule.clockOutSchedule) &&
            moment(dateYesterday).isSame(schedule.clockInScheduleDate))
      );

      todaySchedule.forEach((schedule) => {
        if (this.checkTimeSheet(schedule).length == 0) {
          scheduleFinal.push(schedule);
        }
      });

      if (scheduleFinal.length == 1) {
        this.isDisableClockInButton = false;
      } else if (scheduleFinal.length == 0) {
        this.isDisableClockInButton = true;
      } else {
        this.isDisableClockInButton = false;
      }
    },

    /*
        async toDisableClockInButton(schedForClockIn) {
            const dateNow = moment().format("YYYY-MM-DD");
            const dateYesterday = moment().subtract(1, 'days').format("YYYY-MM-DD");

            const scheduleFinal = schedForClockIn.filter(schedule => {
                const isToday = moment(schedule.clockInScheduleDate).isSame(dateNow);
                const isOvernight = moment(schedule.clockOutSchedule).isSame(dateNow) &&
                                    moment(schedule.clockInScheduleDate).isSame(dateYesterday);

                return (isToday || isOvernight) && this.checkTimeSheet(schedule).length === 0;
            });

            this.isDisableClockInButton = scheduleFinal.length === 0;
        },
        */

    async toDisableClockOutButton(schedForClockOut) {
      let dateNow = moment(new Date()).format("YYYY-MM-DD");

      const todaySchedule = schedForClockOut.filter(
        (schedule) =>
          moment(dateNow).isSame(schedule.clockOutSchedule) ||
          moment(dateNow).isSame(schedule.clockInSchedule)
      );

      if (todaySchedule.length == 1) {
        this.isDisableClockOutButton = false;
      } else if (todaySchedule.length == 0) {
        this.isDisableClockOutButton = true;
      } else {
        this.isDisableClockOutButton = false;
      }
    },
  }, //END OF METHODS
};
</script>
<style scoped>
.btn-view-timesheet {
  font-size: 10px;
  padding: 10px;
  height: auto;
  /* display: block; */
  margin-top: 5px;
}

@media (max-width: 700px) {
  .btn-view-timesheet {
    width: 100%;
  }
}
</style>
